import {
  GET_SORTIE,
  ADD_SORTIE,
  UPDATE_SORTIE,
  DELETE_SORTIE,
  ERROR_XHR
} from '../mutation-types'

import toastr from 'toastr'

const state = {
  all: []
}

const mutations = {
  [GET_SORTIE] (state, sorties) {
    state.all = sorties
  },
  [ADD_SORTIE] (state, project) {
    state.all.push(project)
    toastr.success('La fiche de SORTIE a été créée')
  },
  [UPDATE_SORTIE] (state, oldProject, updatedProject) {
    state.all.$remove(oldProject)
    state.all.push(updatedProject)
    toastr.success('La fiche de SORTIE a été modifiée')
  },
  [DELETE_SORTIE] (state, project) {
    state.all.$remove(project)
    toastr.success('La fiche de SORTIE a été supprimée')
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/sorties.js